import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { S_WebButtonSmaller } from 'elements/button/WebButton';
import { motion } from 'framer-motion';
import { EBorders, EColors, EFonts, EShadows } from 'libs/styles/styling';
import { useContext, useEffect, useRef } from 'react';
import Confetti from 'react-confetti';
import useWindowSize from 'react-use/lib/useWindowSize';
import { CtxEdit } from 'session/ctxEdit';
import { Localization } from 'static/localization/localization';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
}

export const MinuteWelcome = (props: Props): JSX.Element => {
    const ctxEdit = useContext(CtxEdit);
    const ref = useRef<HTMLDivElement>(null);
    const { width, height } = useWindowSize();

    useEffect(() => {
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) {
                ctxEdit.setMapWelcomed(true);
            }
        }

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    if (ctxEdit.mapWelcomed || ctxEdit.worldMarkers?.length > 0) {
        return <></>;
    }

    return (
        <>
            <Confetti width={width} height={height} canvasRef={undefined} />
            <S_MinuteWelcome className={props.className} ref={ref}>
                <S_Content
                    initial={{ opacity: 0, scale: 0.8 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 0.2 }}
                >
                    <S_Title>{Localization.CONGRAT_TITLE}</S_Title>
                    <S_Description>{Localization.CONGRAT_DESC}</S_Description>
                    <S_Item>
                        <S_Icon icon={['fal', 'arrow-down-to-line']} />
                        <S_Right>
                            <S_Subtitle>{Localization.MARKER_SELECTION}</S_Subtitle>
                            <S_Subdescription>
                                {Localization.MARKER_SELECTION_DESC}
                            </S_Subdescription>
                        </S_Right>
                    </S_Item>
                    <S_Item>
                        <S_Icon icon={['fal', 'arrow-right-to-line']} />
                        <S_Right>
                            <S_Subtitle>{Localization.STYLING}</S_Subtitle>
                            <S_Subdescription>{Localization.STYLING_DESC}</S_Subdescription>
                        </S_Right>
                    </S_Item>
                    <S_Mid>
                        <S_WebButton
                            shadow={EShadows.LIGHT}
                            type={'primary'}
                            text={Localization.START_ACTION}
                            onClick={() => {
                                ctxEdit.setMapWelcomed(true);
                            }}
                        />
                    </S_Mid>
                </S_Content>
            </S_MinuteWelcome>
        </>
    );
};

const S_MinuteWelcome = styled.div`
    width: 250px;
    display: flex;
    flex-direction: column;
`;

const S_Content = styled(motion.div)`
    display: flex;
    flex-direction: column;
    align-items: left;
    width: 100%;
    background-color: #efefef;
    border-radius: 7px;
    box-shadow: 5px 5px 10px 0px rgba(0, 0, 0, 0.1);
    border: 1px solid ${EBorders.DARK};
    padding: 25px;
`;

const S_Title = styled.div`
    font-size: 16px;
    color: ${EColors.DARK};
    font-family: ${EFonts.Medium};
    margin: 0 0 8px 0;
`;

const S_Description = styled.div`
    font-size: 15px;
    color: ${EColors.DARK};
    font-family: ${EFonts.Regular};
    line-height: 25px;
    margin: 5px 0 20px 0;
`;

const S_Item = styled.div`
    display: flex;
    margin: 0 0 20px 0;
`;

const S_Icon = styled(FontAwesomeIcon)`
    color: ${EColors.DARK};
    font-size: 25px;
    margin: 0px 15px 0 0;
    width: 25px;
`;

const S_Subtitle = styled.div`
    font-size: 16px;
    color: ${EColors.DARK};
    font-family: ${EFonts.Medium};
    margin: 0 0 2px 0;
`;

const S_Subdescription = styled.div`
    font-size: 15px;
    color: ${EColors.DARK};
    font-family: ${EFonts.Regular};
    line-height: 25px;
`;

const S_Right = styled.div`
    display: flex;
    flex-direction: column;
`;

const S_Mid = styled.div`
    display: flex;
    justify-content: center;
`;

const S_WebButton = styled(S_WebButtonSmaller)`
    margin: 10px 0 15px 0;
`;
